import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["passwordShown", "toggleVisibility"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { InputField } from '../InputField';
import { EyeCrossedIcon, EyeIcon } from './icons';
import * as styles from './PasswordField.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var PasswordField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var passwordShown = _ref.passwordShown,
    toggleVisibility = _ref.toggleVisibility,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputType = React.useMemo(function () {
    return passwordShown ? 'text' : 'password';
  }, [passwordShown]);
  var icon = React.useMemo(function () {
    return passwordShown ? /*#__PURE__*/_jsx(EyeCrossedIcon, {}) : /*#__PURE__*/_jsx(EyeIcon, {});
  }, [passwordShown]);
  return /*#__PURE__*/_jsx(InputField, _objectSpread(_objectSpread({
    "data-name": "PasswordField"
  }, props), {}, {
    ref: ref,
    type: inputType,
    addon: /*#__PURE__*/_jsx("button", {
      className: styles['addon'],
      disabled: props.disabled,
      type: "button",
      onClick: toggleVisibility,
      children: icon
    })
  }));
});
PasswordField.displayName = 'PasswordField';